import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useSelector } from "react-redux";


const ProtectedLoginRoute = () => {
  const userDetails = useSelector((state) => state.root.userDetails);
  let token = Cookies.get("token");
  return !token ? <Outlet /> : <Navigate to={RoutesLink?.dashboard} />;
};
export default ProtectedLoginRoute;
